import { render } from "./form-page.vue?vue&type=template&id=f62018dc&scoped=true"
import script from "./form-page.vue?vue&type=script&lang=js"
export * from "./form-page.vue?vue&type=script&lang=js"

import "./form-page.vue?vue&type=style&index=0&id=f62018dc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f62018dc"]])

export default __exports__